import { useDialog } from "../../../../../utils/hooks/use-dialog";
import {
  SegmentCrudDataGridDialogV2Edit,
  SegmentCrudDataGridDialogV2New,
} from "../../../../segment/components/manager/segment-crud-data-grid-dialog-v2";
import { SegmentSelectField } from "./segment-select-field";

import type { UseSupabaseLoaderState } from "../../../../../server/supabase/hooks/types";
import type { UUID } from "../../../../../utils/uuid";
import type { SupabaseSegmentWithFavourite } from "../../../../segment/server/supabase-segment-service";
import type { SegmentInfo, SegmentModalData } from "./segment-select-field";
import type { FC } from "react";

export const SegmentSelect: FC<{
  segmentLoader: UseSupabaseLoaderState<SupabaseSegmentWithFavourite[]>;
  onChange: (id: UUID | null) => void;
  segmentInfo?: SegmentInfo;
  allowNewSegment?: boolean;
  disabled?: boolean;
  loading?: boolean;
}> = ({ onChange, ...props }) => {
  const {
    open: segmentModalOpen,
    handleOpen: openSegmentModal,
    handleClose: closeSegmentModal,
    data: segmentModalData,
  } = useDialog<SegmentModalData>();

  return (
    <SegmentSelectField
      {...props}
      onChange={onChange}
      openSegmentModal={openSegmentModal}
      modals={
        <>
          {/* Modals handled via conditional rendering */}
          {segmentModalOpen && segmentModalData?.mode === "add" && (
            <SegmentCrudDataGridDialogV2New
              open={segmentModalOpen}
              is_recipient_type={false}
              onClose={closeSegmentModal}
              nameRequired={false}
              onSave={onChange}
            />
          )}
          {segmentModalOpen && segmentModalData?.mode === "edit" && (
            <SegmentCrudDataGridDialogV2Edit
              is_recipient_type={false}
              onClose={closeSegmentModal}
              segment_id={segmentModalData.id}
              disabled={false}
              nameRequired={false}
            />
          )}
        </>
      }
    />
  );
};
